import React from 'react';
import { View } from 'react-native';
import Icon from '@/components/Icon';
import Text from '@/components/Typography/Text';

export default function WorkApprovalTriggerContent({ mode, narrow, disabled, colors }) {
  const color = mode.id === 'full' ? colors.color_warning || '#d97706' : colors.text_color_secondary;
  return <View style={{ flexDirection: 'row', alignItems: 'center', gap: 6, height: 34, paddingHorizontal: 9, borderRadius: 18, opacity: disabled ? 0.5 : 1 }}>
    <Icon name={mode.icon} size={14} color={color} />
    {!narrow && <Text size="s" numberOfLines={1} style={{ color }}>{mode.label}</Text>}
    <Icon name="chevron-down" size={8} color={color} />
  </View>;
}
